import type { AsyncData } from 'nuxt/app'

export const useAsyncDataStatus = (asyncData: AsyncData<any, Error | null>) => {
  const isPending = computed(
    () => asyncData.pending.value && asyncData.status.value !== 'idle'
  )

  return { isPending }
}
